var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartActive = function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF4C4C",
    stroke: "#FF4C4C",
    d: "m11.862 4.054.004-.004a4.92 4.92 0 0 1 7.047-.003 5.146 5.146 0 0 1 .007 7.06l-7.434 6.996a.5.5 0 0 1-.685 0l-7.442-6.998a4.92 4.92 0 0 1 .003-7.046l.01-.01a4.92 4.92 0 0 1 7.049 0l.002.003c.02.02.052.064.122.17l.01.014c.052.08.138.209.237.307l.354.348.351-.35c.097-.098.182-.226.235-.305l.01-.015c.07-.105.102-.149.12-.167Z"
  })));
};
export default SvgHeartActive;